import './ShopBanner.css';
import weinflaschen from '../../assets/images/Weinflaschen.png';

function ShopBanner({ onOpenShop }) {
  return (
    <section id="shop" className="shop-banner">
      <div className="shop-banner__card">
        <div className="shop-banner__logo-wrap">
          <img src={weinflaschen} alt="Rocaille Weinflaschen" className="shop-banner__logo" />
        </div>

        <div className="shop-banner__divider" />

        <div className="shop-banner__content">
          <span className="shop-banner__label">Weinshop</span>
          <h2 className="shop-banner__title">
            Mehr als 2400 Weine für Zuhause,<br />
            jetzt im Rocaille-Weinshop entdecken
          </h2>
          <button className="shop-banner__btn" onClick={onOpenShop}>Zum Shop</button>
        </div>
      </div>
    </section>
  );
}

export default ShopBanner;
